import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Roles } from '@tips-sso/shared';
import { ProtectedRoute, RoleRoute } from './auth/AuthContext.js';
import { CallbackPage, SilentRenewPage } from './auth/CallbackPage.js';
import { Layout } from './components/Layout.js';
import { OrgsPage } from './pages/OrgsPage.js';
import { OrgDetailPage } from './pages/OrgDetailPage.js';
import { ResellersPage } from './pages/ResellersPage.js';
import { ResellerCustomersPage } from './pages/ResellerCustomersPage.js';
import { CustomerUsersPage } from './pages/CustomerUsersPage.js';
import { CustomerEntitlementsPage } from './pages/CustomerEntitlementsPage.js';
import { CustomerIdentityPage } from './pages/CustomerIdentityPage.js';
import { CustomerMicrosoftPage } from './pages/CustomerMicrosoftPage.js';
import { SalesAccountsPage } from './pages/SalesAccountsPage.js';
import { ScimPage } from './pages/ScimPage.js';
import { AuditPage } from './pages/AuditPage.js';

// Either TipsConnect role may use the console; individual pages further gate by need.
const CONSOLE_ROLES = [Roles.TipsConnectAdmin, Roles.TipsConnectSalesOpsUser] as const;

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <CallbackPage /> },
  { path: '/auth/silent-renew', element: <SilentRenewPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <RoleRoute roles={CONSOLE_ROLES}>
          <Layout />
        </RoleRoute>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/tipsconnect/admin/orgs" replace /> },
      { path: 'tipsconnect/admin/orgs', element: <OrgsPage /> },
      { path: 'tipsconnect/admin/orgs/:id', element: <OrgDetailPage /> },
      { path: 'tipsconnect/admin/resellers', element: <ResellersPage /> },
      {
        path: 'tipsconnect/admin/resellers/:id/customers',
        element: <ResellerCustomersPage />,
      },
      { path: 'tipsconnect/admin/customers/:id/users', element: <CustomerUsersPage /> },
      {
        path: 'tipsconnect/admin/customers/:id/entitlements',
        element: <CustomerEntitlementsPage />,
      },
      { path: 'tipsconnect/admin/customers/:id/identity', element: <CustomerIdentityPage /> },
      { path: 'tipsconnect/admin/customers/:id/microsoft', element: <CustomerMicrosoftPage /> },
      { path: 'tipsconnect/admin/sales/accounts', element: <SalesAccountsPage /> },
      { path: 'tipsconnect/admin/scim', element: <ScimPage /> },
      { path: 'tipsconnect/admin/audit', element: <AuditPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
